"use strict";

exports.__esModule = true;
exports.LocalizationContext = void 0;
exports.useLocalizationContext = useLocalizationContext;
var _react = require("react");
var _locales = require("./locales");
var LocalizationContext = exports.LocalizationContext = /*#__PURE__*/(0, _react.createContext)({
  currentLocale: _locales.defaultLocale,
  availableLocales: _locales.locales,
  siteLocales: _locales.locales,
  defaultLocale: _locales.defaultLocale,
  currentPath: '/',
  basePath: '/'
});
function useLocalizationContext() {
  return (0, _react.useContext)(LocalizationContext);
}